import React from "react";
// import { connect } from "react-redux";
import { INTERNAL_LINKS } from "enum";
import { Route } from "react-router-dom";
import { MainHeader, PublicHeader } from "components";

const EventsCouncilShift = () => {

    return (
        <>
            {localStorage.getItem("community") !== null ?
                <Route
                    path={INTERNAL_LINKS.EVENTS_COUNCIL}
                    render={(props) => <MainHeader typeStyle={'black'} {...props} />}
                />
                :
                <Route
                    path={INTERNAL_LINKS.EVENTS_COUNCIL}
                    exact
                    render={(props) => <PublicHeader {...props} />}
                />
            }

        </>
    );
};

// const mapStateToProps = (state) => ({
// });

// const mapDispatchToProps = {
// };

export default EventsCouncilShift;